import React, { useState } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { Label } from './styled';

const FORMAT = 'YYYY/MM/DD';

const ChooseDate = ({
  onChange,
  start,
  end,
  label,
  required = false,
  format = FORMAT,
  widthLabel,
  isPopup = true,
  widthInput,
  height = 40,
  className,
}) => {
  const [internalValue, setInternalValue] = useState([
    start ? dayjs(start, format) : null,
    end ? dayjs(end, format) : null,
  ]);

  const value = [
    start ? dayjs(start, format) : null,
    end ? dayjs(end, format) : null,
  ];

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const [startDate, endDate] = internalValue || [];
      const startStr = startDate ? startDate.format(format) : '';
      const endStr = endDate ? endDate.format(format) : '';

      const isValidStart = !startStr || dayjs(startStr, format, true).isValid();
      const isValidEnd = !endStr || dayjs(endStr, format, true).isValid();

      if (isValidStart && isValidEnd) {
        onChange(internalValue, [startStr, endStr]);
      } else {
        setInternalValue([null, null]);
        onChange(null, ['', '']);
      }
    }
  };

  return (
    <div
      className={`flex items-center justify-end gap-4 !text-[14px] ${className}`}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
          gap: '1px',
          width: widthLabel
        }}
      >
        <Label
          style={{
            width: 'max-content',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
            color: '#000000D9',
          }}
        >
          {label}
        </Label>
        {required && <span className="text-red-500">*</span>}
      </div>
      <DatePicker.RangePicker
        placeholder={['yyyy/mm/dd', 'yyyy/mm/dd']}
        format={format}
        allowEmpty={[true, true]}
        value={value}
        width={widthInput ? widthInput : 276}
        height={height}
        isPopup={isPopup}
        onKeyDown={handleKeyDown}
        onChange={(date, dateString) => {
          onChange(date, dateString);
        }}
        className={`h-10 w-[276px] xl:h-8 xl:rounded-[4px] 2xl:h-9 2xl:rounded-[4px]`}
      />
    </div>
  );
};

export default ChooseDate;
